import { useEffect, useState, useCallback } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { AnimatePresence } from "framer-motion";
import { Toaster } from "sonner";
import Preloader from "@/components/Preloader";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Services from "@/components/Services";
import Showcase from "@/components/Showcase";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import Admin from "@/pages/Admin";
import { ContentProvider } from "@/context/ContentContext";
import { scrollToId } from "@/lib/scroll";

function Landing() {
  const [loading, setLoading] = useState(true);
  const [preselectedService, setPreselectedService] = useState("");

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.085, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  const handleQuote = useCallback((serviceName) => {
    setPreselectedService(serviceName);
    scrollToId("#iletisim");
  }, []);

  const finishLoading = useCallback(() => setLoading(false), []);

  return (
    <>
      <AnimatePresence>
        {loading && <Preloader onDone={finishLoading} />}
      </AnimatePresence>
      <Navbar />
      <main>
        <Hero start={!loading} />
        <Marquee />
        <Services onQuote={handleQuote} />
        <Manifesto />
        <Showcase />
        <Contact preselectedService={preselectedService} />
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <ContentProvider>
      <BrowserRouter>
        <div className="min-h-screen bg-obsidian font-body text-zinc-100">
          <div className="grain" />
          <Toaster
            position="bottom-right"
            toastOptions={{
              style: {
                background: "#121216",
                border: "1px solid rgba(212,175,55,0.35)",
                color: "#F4F4F5",
              },
            }}
          />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </div>
      </BrowserRouter>
    </ContentProvider>
  );
}

export default App;
